import {
  useGetNotificationsMutation,
  useMarkNotificationsAsReadMutation,
} from "@/services/modules/chat";
import { NotificationViewModel } from "@/types/chat";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const Notification = ({
  notificationDetail,
}: {
  notificationDetail: NotificationViewModel;
}) => {
  const { title, message, createdOn } = notificationDetail;

  return (
    <div className="bg-[#e9e9e] p-[5px] m-[10px]">
      <div className="text-[16px] font-extrabold">{title}</div>
      <div className="text-[14px]">{message}</div>
      <div className="text-[11px] text-[#989898] self-end">{createdOn}</div>
    </div>
  );
};

export const NotificationScreen = () => {
  const [getNotifications, data] = useGetNotificationsMutation();
  const [markNotificationsAsRead] = useMarkNotificationsAsReadMutation();
  const { category } = useParams<{ category: string }>();

  useEffect(() => {
    if (category) getNotifications(parseInt(category));
    return () => {
      markNotificationsAsRead();
    };
  }, [category]);

  return (
    <div className="flex-1 p-[10px]">
      {data.data &&
        data.data.map((item) => (
          <Notification key={item.createdOn} notificationDetail={item} />
        ))}
    </div>
  );
};
